<template>
  <div id="tests-category" class="ff ff-align-center">
    <transition name="slide-fade">
      <div v-if="view === 'tests'" id="packages">
        <div 
          class="package-toggle ff ff-center" 
          :class="{'open' : packagesOpen}"
          v-on:click="packagesOpen = !packagesOpen"
        >
          <icon name="ui-cross" color="white" size=18 />
          <icon name="ui-chevron-down" color="white" size=18 />
        </div>
        
        <div class="packages-list padding border border-purple" :class="{'open' : packagesOpen}">
          <div class="tests-list-cat-header ff ff-align-between ff-valign-top">
            <h3 class="purple">Packages</h3>
            <span class="tests-list-note purple"><em>For individual tests, click the <strong>‘x’</strong> to close this window.</em></span>
          </div>
          
          <div class="packages-container">
            <ul class="ff-columns ff-text-center">
              <li 
                v-for="(testPackage, p) in packages" 
                class="ff ff-align-center ff-12 ff-md-6" 
                :key="'package-' + p"
              >
                <div class="bg-white ff-12 tile">
                  <router-link :to="testPackage.url">
                    <div v-if="testPackage.icon_url" class="column-image column-image-icon" :style="'background-image: url(' + testPackage.icon_url + ');'"></div>
                    <div class="horizontal-padding min-padding">
                      <h4 class="tile-heading" v-html="testPackage.name"></h4>
                      <hr v-if="testPackage.short_description" class="hr-50">
                      <div v-if="testPackage.short_description"><p>{{ testPackage.short_description }}</p></div>
                    </div>
                  </router-link>
                  <div class="package-actions ff ff-center vertical-padding min-padding no-padding-top">
                    <router-link :to="testPackage.url" class="tests-list-price">
                      <span class="cyan">${{ testPackage.price }} <em class="cyan">(ex GST)</em></span>
                    </router-link>
                    <div class="ff ff-hide tests-list-actions">
                      <div class="tests-list-add" v-on:click="popupHandler(testPackage.index)">
                        <div class="ff"><icon name="ui-plus" color="white" size=18 /></div>
                      </div>
                      <router-link 
                        :to="testPackage.url" 
                        class="tests-list-arrow"
                        @click.native="trackClick(testPackage.index)"
                      >
                        <div class="ff"><icon name="ui-chevron-right" color="white" size=18 /></div>
                      </router-link>
                      <transition name="fade">
                        <div v-if="testPopup === testPackage.index" class="tests-list-popup tests-list-popup-left bg-dark-grey">
                          <div id="test-popup">
                            <transition
                              name="page-swipe"
                              mode="out-in"
                              v-on:before-leave="beforeLeave"
                              v-on:enter="onEnter"
                            >
                              <div 
                                v-if="testPopupPage === 'estimates'" 
                                class="tests-list-popup-estimates" 
                                :key="'tests-list-popup-estimates-'+testPackage.index"
                              >
                                <div class="tests-list-popup-existing">
                                  <h5 class="white">Add to:</h5>
                                  
                                  <div 
                                    v-for="(estimate,e) in estimates" 
                                    v-on:click="addToEstimate(testPackage.index,e)"
                                    class="ff ff-nowrap"
                                    :class="{'in-estimate grey': estimateVoidTests[e].indexOf(testPackage.index) !== -1 && estimate.sampleType === testPackage.sample_type , 'not-same-sampletype grey': estimate.sampleType !== testPackage.sample_type}"
                                    :title="estimate.sampleType === testPackage.sample_type ? (estimateVoidTests[e].indexOf(testPackage.index) !== -1 ? 'Already added to this estimate' : 'Add to this estimate') : 'Cannot add to an estimate of a different sample type'"
                                    :key="'estimate-'+testPackage.index+'-'+e"
                                  >
                                    {{ estimate.displayedType }} Estimate ({{ e+1 }})
                                    <div class="test-popup-tick">
                                      <icon name="ui-tick" color="grey" size=16 /> 
                                    </div>
                                  </div>
                                </div>
                                
                                <div 
                                  class="tests-list-popup-new ff ff-valign-center ff-nowrap"
                                  v-on:click="addToEstimate(testPackage.index)"
                                >
                                  <icon name="ui-plus" color="white" size=18 />
                                  <em class="white">New Estimate</em>
                                </div>
                              </div>
                              
                              <div 
                                v-if="testPopupPage === 'dependents'" 
                                class="tests-list-popup-dependents" 
                                :key="'tests-list-popup-dependents-'+testPackage.index"
                              >
                                <div class="tests-list-popup-dependents-heading">
                                  <em>This test cannot be added by itself.</em>
                                  <h5 class="white">Add with:</h5>
                                </div>
                                <div 
                                  v-for="(parentTest,p) in testPopupParents" 
                                  v-on:click="addDependent(parentTest.index,testPopupEstimate)"
                                  class="ff ff-nowrap"
                                  :key="'parent-test-'+parentTest.index+'-'+p"
                                >
                                  <icon name="ui-plus" color="white" size=18 />
                                  <span v-html="parentTest.name"></span>
                                </div>
                              </div>
                            </transition>
                          </div>
                          
                          <div class="tests-list-popup-close" v-on:click="popupHandler('close')">
                            <icon name="ui-cross" color="white" size=18 />
                          </div>
                        </div>
                      </transition>
                    </div>
                  </div>
                </div>
                
              </li>
            </ul>
          </div>
        </div>
      </div>
    </transition>
    
    <aside id="tests-list">
      <div v-if="categorySlug === 'other' && subCategoryTests.length > 0">
        <div v-for="(subCat, sc) in $store.getters.sampleTypes[3].sub_categories" class="sub-sample-type" :key="'subCategory-'+sc">
          <div class="tests-list-cat-header ff ff-align-between ff-valign-top">
            <h3 class="grey">Individual {{ subCat.name }} Tests</h3>
          </div>
          
          <ul class="tests-list ff-text-left">
            <li 
              v-for="(test, t) in subCategoryTests[sc]" 
              class="ff ff-align-between" 
              :class="$route.path === test.url ? 'active-route' : ''"
              :key="'test-' + t"
            >
              <router-link :to="test.url" class="ff ff-fill tests-list-name">
                <span v-html="test.name"></span>
              </router-link>
              <router-link :to="test.url" class="ff ff-mobile-hide tests-list-price">
                <span>${{ test.price }} <em class="cyan">(ex GST)</em></span>
              </router-link>
              <div class="ff ff-hide tests-list-actions">
                <div class="tests-list-add" v-on:click="popupHandler(test.index)">
                  <div class="ff"><icon name="ui-plus" color="white" size=18 /></div>
                </div>
                <router-link 
                  :to="test.url" 
                  class="tests-list-arrow"
                  @click.native="trackClick(test.index)"
                >
                  <div class="ff"><icon name="ui-chevron-right" color="white" size=18 /></div>
                </router-link>
                <transition name="fade">
                  <div v-if="testPopup === test.index" class="tests-list-popup tests-list-popup-left bg-dark-grey">
                    <div id="test-popup">
                      <transition
                        name="page-swipe"
                        mode="out-in"
                        v-on:before-leave="beforeLeave"
                        v-on:enter="onEnter"
                      >
                        <div 
                          v-if="testPopupPage === 'estimates'" 
                          class="tests-list-popup-estimates" 
                          :key="'tests-list-popup-estimates-'+test.index"
                        >
                          <div class="tests-list-popup-existing">
                            <h5 class="white">Add to:</h5>
                            
                            <div 
                              v-for="(estimate,e) in estimates" 
                              v-on:click="addToEstimate(test.index,e)"
                              class="ff ff-nowrap"
                              :class="{'in-estimate grey': estimateVoidTests[e].indexOf(test.index) !== -1 && estimate.sampleType === test.sample_type , 'not-same-sampletype grey': estimate.sampleType !== test.sample_type}"
                              :title="estimate.sampleType === test.sample_type ? (estimateVoidTests[e].indexOf(test.index) !== -1 ? 'Already added to this estimate' : 'Add to this estimate') : 'Cannot add to an estimate of a different sample type'"
                              :key="'estimate-'+test.index+'-'+e"
                            >
                              {{ estimate.displayedType }} Estimate ({{ e+1 }})
                              <div class="test-popup-tick">
                                <icon name="ui-tick" color="grey" size=16 /> 
                              </div>
                            </div>
                          </div>
                          
                          <div 
                            class="tests-list-popup-new ff ff-valign-center ff-nowrap"
                            v-on:click="addToEstimate(test.index)"
                          >
                            <icon name="ui-plus" color="white" size=18 />
                            <em class="white">New Estimate</em>
                          </div>
                        </div>
                        
                        <div 
                          v-if="testPopupPage === 'dependents'" 
                          class="tests-list-popup-dependents" 
                          :key="'tests-list-popup-dependents-'+test.index"
                        >
                          <div class="tests-list-popup-dependents-heading">
                            <em>This test cannot be added by itself.</em>
                            <h5 class="white">Add with:</h5>
                          </div>
                          <div 
                            v-for="(parentTest,p) in testPopupParents" 
                            v-on:click="addDependent(parentTest.index,testPopupEstimate)"
                            class="ff ff-nowrap"
                            :key="'parent-test-'+parentTest.index+'-'+p"
                          >
                            <icon name="ui-plus" color="white" size=18 />
                            <span v-html="parentTest.name"></span>
                          </div>
                        </div>
                      </transition>
                    </div>
                    
                    <div class="tests-list-popup-close" v-on:click="popupHandler('close')">
                      <icon name="ui-cross" color="white" size=18 />
                    </div>
                  </div>
                </transition>
                
              </div>
            </li>
          </ul>
        </div>
      </div>
      
      <div v-else>
        
        <div class="tests-list-cat-header ff ff-align-between ff-valign-top">
          <h3 class="grey">Individual {{ sampleType.name }} Tests</h3>
        </div>
        
        <ul class="tests-list ff-text-left">
          <li 
            v-for="(test, t) in tests" 
            class="ff ff-align-between" 
            :class="$route.path === test.url ? 'active-route' : ''"
            :key="'test-' + t"
          >
            <router-link :to="test.url" class="ff ff-fill tests-list-name">
              <span v-html="test.name"></span>
            </router-link>
            <router-link :to="test.url" class="ff ff-mobile-hide tests-list-price">
              <span>${{ test.price }} <em>(ex GST)</em></span>
            </router-link>
            <div class="ff ff-hide tests-list-actions">
              <div class="tests-list-add" v-on:click="popupHandler(test.index)">
                <div class="ff"><icon name="ui-plus" color="white" size=18 /></div>
              </div>
              <router-link 
                :to="test.url" 
                class="tests-list-arrow"
                @click.native="trackClick(test.index)"
              >
                <div class="ff"><icon name="ui-chevron-right" color="white" size=18 /></div>
              </router-link>
              <transition name="fade" mode="out-in">
                <div v-if="testPopup === test.index" class="tests-list-popup tests-list-popup-left bg-dark-grey">
                  <div id="test-popup">
                    <transition
                      name="page-swipe"
                      mode="out-in"
                      v-on:before-leave="beforeLeave"
                      v-on:enter="onEnter"
                    >
                      <div 
                        v-if="testPopupPage === 'estimates'" 
                        class="tests-list-popup-estimates" 
                        :key="'tests-list-popup-estimates-'+test.index"
                      >
                        <div class="tests-list-popup-existing">
                          <h5 class="white">Add to:</h5>
                          
                          <div 
                            v-for="(estimate,e) in estimates" 
                            v-on:click="addToEstimate(test.index,e)"
                            class="ff ff-nowrap"
                            :class="{'in-estimate grey': estimateVoidTests[e].indexOf(test.index) !== -1 && estimate.sampleType === test.sample_type , 'not-same-sampletype grey': estimate.sampleType !== test.sample_type}"
                            :title="estimate.sampleType === test.sample_type ? (estimateVoidTests[e].indexOf(test.index) !== -1 ? 'Already added to this estimate' : 'Add to this estimate') : 'Cannot add to an estimate of a different sample type'"
                            :key="'estimate-'+test.index+'-'+e"
                          >
                            {{ estimate.displayedType }} Estimate ({{ e+1 }})
                            <div class="test-popup-tick">
                              <icon name="ui-tick" color="grey" size=16 /> 
                            </div>
                          </div>
                        </div>
                        
                        <div 
                          class="tests-list-popup-new ff ff-valign-center ff-nowrap"
                          v-on:click="addToEstimate(test.index)"
                        >
                          <icon name="ui-plus" color="white" size=18 />
                          <em class="white">New Estimate</em>
                        </div>
                      </div>
                      
                      <div 
                        v-if="testPopupPage === 'dependents'" 
                        class="tests-list-popup-dependents" 
                        :key="'tests-list-popup-dependents-'+test.index"
                      >
                        <div class="tests-list-popup-dependents-heading">
                          <em>This test cannot be added by itself.</em>
                          <h5 class="white">Add with:</h5>
                        </div>
                        <div 
                          v-for="(parentTest,p) in testPopupParents" 
                          v-on:click="addDependent(parentTest.index,testPopupEstimate)"
                          class="ff ff-nowrap"
                          :key="'parent-test-'+parentTest.index+'-'+p"
                        >
                          <icon name="ui-plus" color="white" size=18 />
                          <span v-html="parentTest.name"></span>
                        </div>
                      </div>
                    </transition>
                  </div>
                  
                  <div class="tests-list-popup-close" v-on:click="popupHandler('close')">
                    <icon name="ui-cross" color="white" size=18 />
                  </div>
                </div>
              </transition>
            </div>
          </li>
        </ul>
      
      </div>
      
    </aside>
    
    <article id="test">
      <div>
        <transition 
          name="fade"
          mode="out-in"
        >
          <router-view v-bind:key="$route.params.articleSlug"></router-view>
        </transition>
      </div>
    </article>
  </div>
</template>

<script>

// @ is an alias to /src
export default {
  name: "Tests",
  props: [
    "categorySlug"
  ],
  data() {
    return {
      packagesOpen: true,
      testPopup: false,
      testPopupDependent: false,
      testPopupEstimate: false,
      testPopupPage: 'estimates',
      testPopupParents: [],
      view: 'tests'
    }
  },
  computed: {
    sampleType() {
      let sampleType = {
        name: '',
        slug: '',
        total: '',
        subCategories: []
      };
      
      let sampleTypes = this.$store.getters.sampleTypes;
      
      if (sampleTypes.length > 0){
        let s = sampleTypes.find(s => s.slug == this.categorySlug);
        
        sampleType.name = s.name;
        sampleType.slug = s.slug;
        sampleType.total = s.total_tests;
        sampleType.subCategories = s.sub_categories;
      }
      
      return sampleType;
    },
    packages() {
      let packages = [];
      let storeTests = this.$store.getters.tests;
      
      if (storeTests.length > 0){
        let p = storeTests.filter(t => (t.sample_type_slug == this.categorySlug && t.test_type === 0 && t.list_visibility > 0));
        
        packages = p;
        
        packages.sort(function(a, b){
            return a.ordering-b.ordering
        });
      }
      
      return packages;
    },
    tests() {
      let tests = [];
      
      let storeTests = this.$store.getters.tests;
      
      if (storeTests.length > 0){
        let t = storeTests.filter(t => (t.sample_type_slug == this.categorySlug && t.test_type > 0 && t.list_visibility > 0));
        
        tests = t;
      }
      
      return tests;
    },
    subCategoryTests() {
      let subCategoryTests = [];
      let storeTests = this.$store.getters.tests;
      let sampleTypes = this.$store.getters.sampleTypes;
      
      if (sampleTypes.length > 0 && this.categorySlug === 'other'){
        let subCategories = sampleTypes[3].sub_categories;
        
        for (var i = 0; i < subCategories.length; i++) {
          let subName = subCategories[i].name;
          let subTests = storeTests.filter(t => (t.sample_type == subName && t.test_type > 0 && t.list_visibility > 0));
          
          subCategoryTests.push( subTests );
        }
        
      }
      
      return subCategoryTests;
    },
    estimates () {
      var estimates = this.$store.state.calculator.estimates;
      return estimates;
    },
    currentEstimate () {
      var currentEstimate = this.$store.state.calculator.currentEstimate;
      return currentEstimate;
    },
    estimateVoidTests() {
      var estimateVoidTests = [];
      
      if(this.$store.state.calculator.estimates.length > 0){
        this.$store.state.calculator.estimates.forEach(function(estimate){
          var tests = [];
          
          if(estimate.tests.individual.length > 0){
            estimate.tests.individual.forEach(function(test){
              tests.push(test.index);
            });
          }
          
          if(estimate.tests.optimal.length > 0){
            estimate.tests.optimal.forEach(function(test){
              if(tests.indexOf(test.index) === -1) {
                tests.push(test.index);
              }
            });
          }
          
          estimateVoidTests.push(tests);
        });
      }
      
      return estimateVoidTests;
    },
    meta() {
      var meta = {
        title: "Tests",
        url: "https://www.csbplab.com.au/tests/"+this.categorySlug,
        desc: "",
        image: ""
      }
      
      if(this.sampleType.name){
        meta.title = "Tests | "+this.sampleType.name;
      }
      
      return meta;
    }
  },
  beforeMount() {
    if(this.$route.name === 'Tests') {
      this.view = 'tests';
    } else if(this.$route.name === 'Test') {
      this.view = 'test';
    } else {
      this.view = 'tests';
    }
  },
  mounted() {
    
  },
  methods: {
    beforeLeave(el) {
      // Attach previous router-view height to popup
      var popup = document.getElementById("test-popup");
      popup.style.height = getComputedStyle(el).height;
      popup.style.width = getComputedStyle(el).width;
    },
    onEnter(el) {
      // Attach new router-view height to popup
      var popup = document.getElementById("test-popup");
      popup.style.height = getComputedStyle(el).height;
      popup.style.width = getComputedStyle(el).width;
      
      // Attach 'auto' height to popup after transition is complete
      setTimeout(function(){
        popup.style.height = 'auto';
        popup.style.width = 'auto';
      }, 1000);
    },
    popupHandler(testIndex) {
      
      if(testIndex === 'close') {
        this.testPopup = false;
      } else {
        this.testPopupEstimate = false;
        this.testPopupDependent = false;
        this.testPopupParents = [];
        this.testPopupPage = 'estimates';
        this.testPopup = testIndex;
      }
      
    },
    trackClick(testIndex) {
      var test = this.$store.state.tests[testIndex];
      var tType = test.test_type;
      var testType = 'individual';
      
      switch(tType) {
        case 0:
          testType = 'package';
          break;
        case 1:
          testType = 'combination';
          break;
        case 2:
          testType = 'individual';
          break;
        case 3:
          testType = 'option';
          break;
        default:
          testType = 'individual';
      }
      
      this.$gtm.trackEvent({
        'event': 'tests',
        'action': 'click',
        'test-category': test.sample_type_slug,
        'test-name': test.name,
        'test-type': testType
      });
    },
    addToEstimate(testIndex,estimateIndex = false) {
      var vm = this;
      var test = this.$store.state.tests[testIndex];
      var alreadyExists = false;
      var parentExists = false;
      var isSameSampleType = true;
      var estimateType = 'new estimate'; 
      
      // Conditional checks
      if(estimateIndex !== false){
        var estimate = this.$store.state.calculator.estimates[estimateIndex];
        
        if(estimate.tests.individual.some(t => t.index === testIndex) || estimate.tests.optimal.some(t => t.index === testIndex)) {
          alreadyExists = true;
        }
        
        if(test.test_type === 3) {
          if(estimate.tests.individual.some(t => test.parents.indexOf(t.test_id) !== -1) || estimate.tests.optimal.some(t => test.parents.indexOf(t.test_id) !== -1)) {
            parentExists = true;
          }
        }
        
        if(test.sample_type !== estimate.sampleType) {
          isSameSampleType = false;
        }
        
        estimateType = 'existing estimate';
      } 
      
      // If doesn't exist and is same sample type
      if(!alreadyExists && isSameSampleType){
        
        // If is a dependent
        if(test.test_type === 3) {
          
          this.testPopupEstimate = estimateIndex;
          this.testPopupDependent = testIndex;
          
          // If a parent test exists in estimate, just add it automatically
          if(parentExists) {
            
            this.testPopup = false;
            setTimeout(vm.dispatchToEstimate(testIndex,estimateIndex), 301);
            
            this.$gtm.trackEvent({
              'event': 'tests',
              'action': 'click',
              'test-category': this.$store.state.tests[testIndex].sample_type_slug,
              'test-name': this.$store.state.tests[testIndex].name,
              'add-to': estimateType
            });
          
          // If a parent doesn't exist in estimate, allow user to select a test
          } else {
            
            this.testPopupParents = this.$store.state.tests.filter(t => test.parents.indexOf(t.test_id) !== -1 && test.sample_type === t.sample_type && (t.test_type === 0 || t.test_type === 2));
            this.testPopupPage = 'dependents';
            
          }
        
        // If is a package, combination or individual test
        } else {
          
          this.testPopup = false;
          setTimeout(vm.dispatchToEstimate(testIndex,estimateIndex), 301);
          
          this.$gtm.trackEvent({
            'event': 'tests',
            'action': 'click',
            'test-category': this.$store.state.tests[testIndex].sample_type_slug,
            'test-name': this.$store.state.tests[testIndex].name,
            'add-to': estimateType
          });
          
        }
        
      }
      
    },
    addDependent(testIndex,estimateIndex = false) {
      var vm = this;
      var depIndex = this.testPopupDependent;
      var estimateType = 'new estimate';
      
      this.testPopup = false;
      setTimeout(vm.dispatchToEstimate([testIndex,depIndex],estimateIndex), 301);
      
      if(estimateIndex !== false){
        estimateType = 'existing estimate';
      }
      
      this.$gtm.trackEvent({
        'event': 'tests',
        'action': 'click',
        'test-category': this.$store.state.tests[testIndex].sample_type_slug,
        'test-name': this.$store.state.tests[testIndex].name,
        'add-to': estimateType
      });
    },
    dispatchToEstimate(testIndex,estimateIndex = false){
      this.$store.dispatch("addToEstimate", {
        test: testIndex,
        estimate: estimateIndex
      });
      
      this.testPopupEstimate = false;
      this.testPopupDependent = false;
      this.testPopupParents = [];
      this.testPopupPage = 'estimates';
    }
  },
  filters: {
    testType(val) {
      var testType = '';
      
      switch(val) {
        case 0:
          testType = 'package';
          break;
        case 1:
          testType = 'combination';
          break;
        case 2:
          testType = 'individual';
          break;
        case 3:
          testType = 'option';
          break;
        default:
          testType = 'individual';
      }
      
      return testType;
    },
    truncate(value) {
      var str = '';
      var val = value.replace(/(<([^>]+)>)/ig,'');
      
      if (val.length > 205) {
        str = val.substring(0,205) + '...';
      } else {
        str = val;
      }
      
      return str;
    }
  },
  watch:{
    // eslint-disable-next-line
    $route (to, from){
      this.testPopup = false;
      
      if(to.name === 'Tests') {
        this.view = 'tests';
      } else if (to.name === 'Test') {
        this.view = 'test';
      } else {
        this.view = 'tests';
      }
    }
  },
  metaInfo () {
    return {
      title: this.meta.title,
      link: [
        {
          rel: "canonical",
          href: this.meta.url
        }
      ],
      meta: [
        {
          name: "description",
          content: this.meta.desc
        },
        {
          property: "og:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "og:url",
          content: this.meta.url
        },
        {
          property: "og:image",
          content: this.meta.image
        },
        {
          property: "og:description",
          content: this.meta.desc
        },
        {
          property: "twitter:title",
          content: this.meta.title + " | CSBP Lab"
        },
        {
          property: "twitter:site",
          content: this.meta.url
        },
        {
          property: "twitter:image.src",
          content: this.meta.image
        },
        {
          property: "twitter:description",
          content: this.meta.desc
        }
      ]
    }
  }
};
</script>